"use client"

import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import axios from "axios"
import { Link, useNavigate } from "react-router-dom"
import { FaBackward } from "react-icons/fa"
import Logo from "../assest/tactosnew.png"
import StartupRegPricing from "../components/StartupRegPricing"
import { initializePayment } from '../utils/paymentUtils'
import { PaymentType } from '../utils/paymentTypes'
import { toast } from "react-hot-toast"
import { uploadImage, uploadFile, getAllIndustries, getAllStages, getCouponByCode } from "../utils/api"
import { useAuth } from "../utils/authContext"


const typewriterTexts = [
  "Find Your Dream Co-Founder",
  "Build Ideas Together",
  "Start Something Big!",
]

export default function StartupReg() {
  const [step, setStep] = useState(0)
  const [formData, setFormData] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const [displayText, setDisplayText] = useState("")
  const [currentIndex, setCurrentIndex] = useState(0)
  const [otpSent, setOtpSent] = useState(false)
  const [emailVerified, setEmailVerified] = useState(false)
  const [otp, setOtp] = useState("")
  const [isCoFounder, setIsCoFounder] = useState(false)
  const [logoUploading, setLogoUploading] = useState(false)
  const [pitchDeckUploading, setPitchDeckUploading] = useState(false);
  const [industries, setIndustries] = useState([]);
  const [apiStages, setApiStages] = useState([]);
  const [emailExists, setEmailExists] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [paymentProcessing, setPaymentProcessing] = useState(false)
  const [registrationData, setRegistrationData] = useState(null)
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [tactosCoupon, setTactosCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");

  const navigate = useNavigate()

  useEffect(() => {
    let current = 0, forward = true
    const interval = setInterval(() => {
      const txt = typewriterTexts[currentIndex]
      if (forward) {
        setDisplayText(txt.slice(0, current + 1)); current++
        if (current > txt.length) forward = false
      } else {
        setDisplayText(txt.slice(0, current - 1)); current--
        if (current === 0) {
          forward = true
          setCurrentIndex(i => (i + 1) % typewriterTexts.length)
        }
      }
    }, 100)
    return () => clearInterval(interval)
  }, [currentIndex])

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [industriesRes, stagesRes] = await Promise.all([
          getAllIndustries(),
          getAllStages()
        ]);
        setIndustries(industriesRes);
        setApiStages(stagesRes);
      } catch (error) {
        console.error("Error fetching dropdown data", error);
      }
    };

    fetchDropdownData();
  }, []);

  // useEffect(() => {
  //   const handleBeforeUnload = async (e) => {
  //     const startupId = localStorage.getItem("startupId");
  //     const token = localStorage.getItem("Startuptoken");

  //     if (startupId && showPaymentModal) {
  //       e.preventDefault();
  //       try {
  //         await axios.delete(`${process.env.REACT_APP_API_URL}/api/startups/unpaid/${startupId}`, {
  //           headers: { Authorization: `Bearer ${token}` }
  //         });
  //       } catch (error) {
  //         console.error("Cleanup failed:", error);
  //       }
  //     }
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  // }, [showPaymentModal]);

  // Validation helpers…
  const validateEmail = async (email) => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || !email.endsWith(".com")) {
      return false;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/check-email`, { email });
      setEmailExists(response.data.exists);
      return !response.data.exists;
    } catch (error) {
      console.error("Email check failed:", error);
      return false;
    }
  };

  const validatePhone = p => /^[0-9]{10}$/.test(p)
  const validateField = (f, v) =>
    f.type === "email" ? validateEmail(v)
      : f.type === "tel" ? validatePhone(v)
        : v !== ""

  const handleSendOtp = async () => {
    if (!validateEmail(formData.email)) {
      setErrorMessage("Invalid email format.");
      return;
    }

    if (emailExists) {
      setErrorMessage("Email already registered.");
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/send-otp`, { email: formData.email });
      setOtpSent(true);
      setErrorMessage("");
    } catch {
      setErrorMessage("Failed to send OTP.");
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/verify-otp`, {
        email: formData.email, otp
      })
      if (res.data.success) {
        setEmailVerified(true)
        setErrorMessage("")
      } else {
        setErrorMessage("Incorrect OTP")
      }
    } catch {
      setErrorMessage("Verification failed")
    }
  }

  const handleLogoUpload = async e => {
    const file = e.target.files?.[0]
    if (!file) return
    setLogoUploading(true)
    try {
      const data = await uploadImage(file)
      setFormData(fd => ({ ...fd, logoUrl: data.url }))
      setErrorMessage("")
    } catch {
      setErrorMessage("Logo upload failed")
    } finally {
      setLogoUploading(false)
    }
  }

  const handleChange = async (e) => {
    const { name, type, value, files } = e.target;

    if (type === "file") {
      setFormData((fd) => ({ ...fd, [name]: files[0] }));
    } else if (type === "tel") {
      const num = value.replace(/\D/g, "").slice(0, 10);
      setFormData((fd) => ({ ...fd, [name]: num }));
    } else {
      if (name === "email") {
        setFormData((fd) => ({ ...fd, [name]: value }));
        if (value !== formData.email) {
          setOtpSent(false);
          setEmailVerified(false);
          setOtp("");
        }
        if (value) {
          await validateEmail(value);
        } else {
          setEmailExists(false);
        }
      } else {
        setFormData((fd) => ({ ...fd, [name]: value }));
      }
    }
  };

  const handleMultiSelect = (n, v) => setFormData(fd => {
    const cur = fd[n] || []
    return { ...fd, [n]: cur.includes(v) ? cur.filter(x => x !== v) : [...cur, v] }
  })

  const handleNext = () => {
    const currentSection = sections[step];

    if (currentSection.fields.some(field => field.name === "email") && !emailVerified) {
      setErrorMessage("⚠️ Please verify your email with OTP before proceeding.");
      return;
    }

    for (let f of currentSection.fields) {
      if (!f.optional) {
        const v = formData[f.name];
        if (!v || !validateField(f, v)) {
          setErrorMessage(`⚠️ Please correctly fill out: ${f.label}`);
          return;
        }
      }
    }

    if (step === sections.length - 1 && !formData.logoUrl) {
      setErrorMessage("⚠️ Logo upload is required");
      return;
    }

    setErrorMessage("");
    setStep(s => s + 1);
  };

  const { loginStartup } = useAuth();

  const fetchCoupon = async () => {
    if (!formData.coupon) return;

    try {
      const couponData = await getCouponByCode(formData.coupon);

      if (!couponData) {
        setCouponError("❌ Invalid coupon code.");
        setTactosCoupon(null);
        return;
      }

      // Check expiry and active status
      const now = new Date();
      const expiry = new Date(couponData.expiryDate);

      if (!couponData.isActive || expiry < now) {
        setCouponError("⚠️ This coupon is expired or inactive.");
        setTactosCoupon(null);
        return;
      }

      // Valid coupon
      setTactosCoupon({
        code: couponData.code,
        discount: couponData.discount,
      });
      setCouponError(""); // clear any previous error

      console.log("✅ Coupon Applied:", couponData);
    } catch (err) {
      console.error(err);
      setCouponError("❌ Failed to fetch coupon. Try again.");
      setTactosCoupon(null);
    }
  };

  useEffect(() => {
    fetchCoupon();
  }, [formData.coupon]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!emailVerified) {
      setErrorMessage("⚠️ Please verify your email with OTP before submitting.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/register`,
        {
          fullName: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          password: formData.password,
          linkedin: formData.linkedin || undefined
        }
      );

      if (response.data.token) {
        localStorage.setItem("startupId", response.data.startup.id);
        localStorage.setItem("fullName", response.data.startup.fullName);
        localStorage.setItem("email", response.data.startup.email);
        localStorage.setItem("userPhone", response.data.startup.phone);

        loginStartup(response.data.token);
      }

      setRegistrationData(response.data.startup || response.data);

      setShowPaymentModal(true);

    } catch (err) {
      console.error("Registration error:", err);
      setErrorMessage(`${err.response?.data?.message || err.message || 'Registration failed'}`);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentModalClose = async () => {
    try {
      const startupId = localStorage.getItem("startupId");
      const token = localStorage.getItem("Startuptoken");

      if (startupId) {
        await axios.delete(`${process.env.REACT_APP_API_URL}/api/startups/unpaid/${startupId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        localStorage.removeItem("startupId");
        localStorage.removeItem("Startuptoken");
      }

      setShowPaymentModal(false);
      setLoading(false);
    } catch (error) {
      console.error("Error cleaning up unpaid registration:", error);
      toast.error("Failed to clean up registration. Please contact support.");
    }
  };

  const tamilNaduDistricts = [
    "Ariyalur",
    "Chengalpattu",
    "Chennai",
    "Coimbatore",
    "Cuddalore",
    "Dharmapuri",
    "Dindigul",
    "Erode",
    "Kallakurichi",
    "Kanchipuram",
    "Kanyakumari",
    "Karur",
    "Krishnagiri",
    "Madurai",
    "Mayiladuthurai",
    "Nagapattinam",
    "Namakkal",
    "Nilgiris",
    "Perambalur",
    "Pudukkottai",
    "Ramanathapuram",
    "Ranipet",
    "Salem",
    "Sivaganga",
    "Tenkasi",
    "Thanjavur",
    "Theni",
    "Thoothukudi",
    "Tiruchirappalli",
    "Tirunelveli",
    "Tirupathur",
    "Tiruppur",
    "Tiruvallur",
    "Tiruvannamalai",
    "Tiruvarur",
    "Vellore",
    "Viluppuram",
    "Virudhunagar",
  ];

  const sections = [
    {
      title: "Personal Information",
      fields: [
        { label: "Full Name", name: "fullName", type: "text" },
        { label: "Email Address", name: "email", type: "email" },
        { label: "Phone Number", name: "phone", type: "tel" },
        { label: "LinkedIn Profile", name: "linkedin", type: "url", optional: true },
        { label: "Reedeem Code (Optional)", name: "coupon", type: "text", optional: true },
      ],
    },
  ];

  const handleToggle = () => {
    setIsCoFounder(c => !c)
    if (!isCoFounder) navigate("/cofounder-reg")
  }

  const restrictInput = (type, e) => {
    const value = e.nativeEvent.data;
    if (!value) return;
    if (type === "text" && /\d/.test(value)) e.preventDefault();
    if (type === "tel" && /\D/.test(value)) e.preventDefault();
  };

  const handlePitchDeckUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setPitchDeckUploading(true);
    try {
      const data = await uploadFile(file);
      setFormData(fd => ({ ...fd, pitchDeckUrl: data.url }));
      setErrorMessage("");
    } catch (err) {
      setErrorMessage("Pitch deck upload failed");
    } finally {
      setPitchDeckUploading(false);
    }
  };

  return (
    <div className="w-full h-[100dvh] lg:h-screen bg-gradient-to-br from-red-500 via-red-300 to-yellow-100 flex items-center justify-center p-4 overflow-hidden">
      <div className="w-full h-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
        <div className="md:w-1/2 w-full bg-white px-8 py-6 h-full overflow-y-auto">
          <div className="flex justify-start mb-4">
            <Link to="/" className="flex items-center space-x-2">
              <img src={Logo} alt="Back to Home" className="w-28" />
            </Link>
          </div>

          <h2 className="text-3xl font-bold text-center text-gray-800 mt-4 mb-6">
            Sign up
          </h2>

          {submitted ? (
            <div className="text-center mt-6">
              <h3 className="text-2xl font-semibold text-green-600 mb-4">
                🎉 Registration Successful!
              </h3>
              <button
                onClick={() => {
                  setSubmitted(false);
                  setStep(0);
                  setFormData({});
                  setOtpSent(false);
                  setEmailVerified(false);
                  setOtp("");
                }}
                className="px-6 py-2 bg-indigo-600 text-white rounded-full hover:bg-indigo-700"
              >
                Register Another Startup
              </button>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="space-y-4 text-sm w-full lg:w-1/2 mx-auto"
            >
              {/* Error message */}
              {errorMessage && (
                <motion.div
                  initial={{ y: -10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.2 }}
                  className="bg-red-100 text-red-700 p-3 rounded text-sm"
                >
                  {errorMessage}
                </motion.div>
              )}

              {/* Progress Dots */}
              <div className="flex justify-center space-x-2 mt-4">
                {sections.map((_, index) => (
                  <span
                    key={index}
                    className={`h-2 w-8 rounded-full transition-all duration-300 ${index <= step ? "bg-[#4b154c]" : "bg-gray-300"
                      }`}
                  />
                ))}
              </div>

              {/* Section Title */}
              <h3 className="text-lg font-medium text-[#4b154c] text-center">
                {sections[step]?.title}
              </h3>

              {/* Current step's fields */}
              {sections[step]?.fields.map((field, idx) => (
                <div key={idx} className="flex flex-col">
                  <label
                    htmlFor={field.name}
                    className="text-gray-700 font-medium mb-1"
                  >
                    {field.label}
                  </label>

                  {/* Email w/ OTP */}
                  {field.type === "email" ? (
                    <>
                      <div className="flex items-center space-x-2">
                        <input
                          id={field.name}
                          type="email"
                          name={field.name}
                          value={formData[field.name] || ""}
                          onChange={handleChange}
                          disabled={emailVerified}
                          className={`w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 ${formData.email && emailExists ? "focus:ring-red-500" : "focus:ring-indigo-300"
                            } border-none`}
                          placeholder="Your Email"
                        />
                        {!emailVerified && !emailExists && (
                          <button
                            type="button"
                            onClick={handleSendOtp}
                            className="bg-[#4b154c] text-white rounded-full px-4 py-2 hover:bg-blue-700 text-sm"
                          >
                            Verify
                          </button>
                        )}
                        {emailVerified && (
                          <svg
                            className="w-6 h-6 text-green-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="3"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        )}
                      </div>
                      {formData.email && emailExists && (
                        <p className="text-red-500 text-xs mt-1">This email is already registered</p>
                      )}

                      {otpSent && !emailVerified && !emailExists && (
                        <div className="mt-2">
                          <input
                            type="text"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 mb-2 border-none"
                            placeholder="Enter OTP"
                            maxLength={6}
                          />
                          <button
                            type="button"
                            onClick={handleVerifyOtp}
                            className="w-full text-center bg-[#4b154c] text-white rounded-full px-4 py-2 hover:bg-green-700 text-sm"
                          >
                            Submit OTP
                          </button>
                        </div>
                      )}

                      {emailVerified && (
                        <div className="space-y-2 mt-2">
                          <input
                            type="password"
                            name="password"
                            value={formData.password || ""}
                            onChange={handleChange}
                            className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                            placeholder="Enter Password"
                          />
                          <input
                            type="password"
                            name="confirmPassword"
                            value={formData.confirmPassword || ""}
                            onChange={handleChange}
                            className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                            placeholder="Confirm Password"
                          />

                          {formData.password && formData.confirmPassword && formData.password !== formData.confirmPassword && (
                            <p className="text-red-500 text-xs mt-1">Passwords do not match</p>
                          )}
                        </div>
                      )}
                    </>
                  )
                    : field.type === "radio" ? (
                      /* Radio buttons */
                      <div className="flex space-x-4">
                        {field.options.map((option, i) => (
                          <label
                            key={i}
                            className="flex items-center space-x-1 text-gray-700"
                          >
                            <input
                              type="radio"
                              name={field.name}
                              value={option}
                              checked={formData[field.name] === option}
                              onChange={handleChange}
                              className="accent-indigo-600 border-none"
                            />
                            <span className="text-sm">{option}</span>
                          </label>
                        ))}
                      </div>
                    ) : field.type === "multiselect" ? (
                      /* Multi-select buttons */
                      <div className="flex flex-wrap gap-2">
                        {field.options.map((option, i) => (
                          <button
                            key={i}
                            type="button"
                            onClick={() => handleMultiSelect(field.name, option)}
                            className={`px-3 py-1 rounded-full border-none text-sm ${formData[field.name]?.includes(option)
                              ? "bg-indigo-600 text-white"
                              : "bg-gray-200 text-gray-700"
                              }`}
                          >
                            {option}
                          </button>
                        ))}
                      </div>
                    ) : field.type === "logo" ? (
                      <div className="flex flex-col">
                        <label className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-full cursor-pointer text-sm w-fit">
                          {logoUploading ? "Uploading…" : "Choose Logo"}
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleLogoUpload}
                            className="hidden"
                          />
                        </label>
                        {formData.logoUrl && (
                          <img src={formData.logoUrl} alt="Logo preview" className="mt-2 h-20 w-20 rounded-full" />
                        )}
                      </div>
                    ) : field.type === "file" ? (
                      <div className="flex flex-col items-start">
                        <label className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-full cursor-pointer text-sm border-none">
                          {pitchDeckUploading ? "Uploading..." : "Choose Pitch Deck"}
                          <input
                            type="file"
                            name={field.name}
                            onChange={handlePitchDeckUpload}
                            className="hidden"
                            accept=".pdf,.ppt,.pptx,.doc,.docx"
                          />
                        </label>
                        {formData.pitchDeckUrl && (
                          <span className="text-gray-600 text-xs mt-2">
                            Pitch deck uploaded successfully
                          </span>
                        )}
                      </div>
                    ) : field.type === "select" ? (
                      <select
                        name={field.name}
                        value={formData[field.name] || ""}
                        onChange={handleChange}
                        className="w-full bg-gray-200 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                      >
                        <option value="">-- Select --</option>
                        {field.options.map((option, i) => (
                          <option key={i} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type={field.type}
                        name={field.name}
                        value={formData[field.name] || ""}
                        onChange={handleChange}
                        onBeforeInput={(e) => restrictInput(field.type, e)}
                        className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                        placeholder={field.type === "text" ? field.label : ""}
                      />
                    )}


                </div>
              ))}
              {couponError && (
                <p className="text-red-500 text-sm mt-1">{couponError}</p>
              )}
              {tactosCoupon && (
                <p className="text-green-600 text-sm mt-1">
                  ✅ Coupon applied! You get {tactosCoupon.discount}% off.
                </p>
              )}
              {/* Button group and login link OUTSIDE the map */}
              <div className="flex items-center justify-between mt-6">
                {step > 0 && (
                  <button
                    type="button"
                    onClick={() => setStep((prev) => prev - 1)}
                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 text-sm"
                  >
                    Back
                  </button>
                )}
                {step < sections.length - 1 && (
                  <button
                    type="button"
                    onClick={handleNext}
                    className="ml-auto px-6 py-2 bg-[#4b154c] text-white rounded-full hover:bg-purple-700 text-sm"
                  >
                    Next
                  </button>
                )}
                {step === sections.length - 1 && (
                  <button
                    type="submit"
                    className="ml-auto px-6 py-2 bg-[#4b154c] text-white rounded-full hover:bg-purple-700 text-sm disabled:opacity-50"
                    disabled={loading || !emailVerified}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                )}
              </div>

              {/* "Already have an account? Log in" */}
              <div className="flex justify-center mb-6">
                <span className="text-gray-600 text-sm">
                  If you already have an account,{" "}
                  <Link to="/login" className="text-indigo-600 hover:underline">
                    Log in
                  </Link>
                </span>
              </div>
            </form>
          )}
        </div>

        {/* RIGHT SIDE (ILLUSTRATION): hidden on small screens */}
        <div className="md:w-1/2 w-full relative overflow-hidden lg:h-full hidden lg:block">
          <img
            src="/s.jpg"
            alt="Startup Illustration"
            className="w-full h-full object-cover"
          />

          <Link
            to="/"
            className="absolute top-4 right-4 flex items-center gap-2 text-black font-bold"
          >
            <FaBackward /> Back to Home
          </Link>
        </div>
      </div>
      {showPaymentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Complete Your Registration</h3>
              <button
                onClick={handlePaymentModalClose}
                className="text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
            </div>

            <div className="mb-6">
              <p className="text-gray-700 mb-4">
                Please select a membership plan to complete your startup registration.
                Your registration will be cancelled if you close this window without payment.
              </p>

              <StartupRegPricing
                coupon={tactosCoupon}
                onPlanSelect={async (plan) => {
                  try {
                    setPaymentProcessing(true);
                    await handlePaymentComplete(plan);
                  } catch (error) {
                    console.error('Payment Error:', error);
                    toast.error(error.message || 'Payment processing failed');
                  } finally {
                    setPaymentProcessing(false);
                  }
                }}
                formData={formData}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}